import { ReactNode, useMemo } from 'react';

import { statuses } from '../consts';
import { useTranslation } from '../i18n';
import { ItemState } from '../types';

interface Status {
  name: string;
  color: string;
  statusText: ReactNode;
  stateText?: ReactNode;
}

export default function useStatus(stateId: ItemState): Status {
  const { t } = useTranslation();
  const status = statuses[stateId];
  const { statusText, stateText } = status;

  return useMemo(
    () => ({
      ...status,
      statusText: t(statusText),
      stateText: stateText && t(stateText),
    }),
    [t, stateText, statusText, status],
  );
}
